var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "col-12",
      attrs: { id: "email-preferences-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "card", attrs: { id: "email-preferences" } }, [
        _c("ul", { staticClass: "list-group list-group-flush" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "grey-text text-darken-3 col-6 text-left align-self-center",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("settings.accountTab.tabs.emailPreferences")
                      ) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.isEmailsEmpty
                ? _c(
                    "div",
                    { staticClass: "col-6 text-right single-line-height" },
                    [
                      _c("simple-button", {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.sync-email-terms-modal",
                            modifiers: { "sync-email-terms-modal": true },
                          },
                        ],
                        attrs: {
                          type: "primary",
                          "class-name": "btn-sm float-right",
                          text: _vm.$t("campaigns.actions.addEmail"),
                        },
                        on: { click: _vm.connectEmailModal },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.isNylasAccountConnected()
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "grey-text text-darken-3 col-10 text-left align-self-center",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "red",
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("i18n", {
                                staticClass: "font-sm moregage-form",
                                attrs: {
                                  path: "settings.accountTab.emailAlreadyConnected",
                                  tag: "p",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "email",
                                      fn: function () {
                                        return [
                                          _c("span", { staticClass: "bold" }, [
                                            _vm._v(
                                              _vm._s(_vm.nylasAccount.email)
                                            ),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "account",
                                      fn: function () {
                                        return [
                                          _c("span", { staticClass: "bold" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nylasAccount.usernameEmail
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1803386258
                                ),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ml-2" },
                            [
                              _c("simple-button", {
                                staticStyle: { "margin-left": "auto" },
                                attrs: {
                                  type: "primary",
                                  "class-name": "btn-sm",
                                  text: _vm.$t(
                                    "settings.accountTab.deleteOldEmailSync"
                                  ),
                                },
                                on: { click: _vm.deleteOldEmailSync },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "list-group-item connect-email-list" },
            [
              _vm._l(_vm.syncedEmails.emails, function (email) {
                return _c(
                  "div",
                  {
                    key: email.nylasAccountId,
                    staticClass: "row align-items-center",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xxl-1 col-lg-2 col-md-3 d-flex flex-column justify-content-center align-items-center",
                      },
                      [
                        _c("img", {
                          staticClass: "email-logo",
                          attrs: {
                            src: _vm._f("emailProviderImage")(email.provider),
                            alt: _vm.emailAltText(email.provider),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xxl-8 col-lg-6 col-md-4 d-flex flex-column justify-content-center align-items-start",
                      },
                      [
                        _c("p", { staticClass: "m-0 text-gray" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(email.email) +
                              "\n              "
                          ),
                          email.defaultAccount
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "badge status-badge complete ml-2 mb-0 my-auto bold",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("global.words.primary")) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "m-0 text-gray" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("settings.accountTab.inboxType")) +
                                ": "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "bold text-capitalize" }, [
                            _vm._v(_vm._s(email.provider)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "m-0 bold text-regular-gray font-sm status-text",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("global.words.enabled")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xxl-3 col-lg-4 col-12 d-flex align-items-center justify-content-end flex-row mt-2",
                      },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.sync-email-terms-modal",
                                modifiers: { "sync-email-terms-modal": true },
                              },
                            ],
                            staticClass:
                              "btn clickable btn-primary btn-sm mr-2",
                            on: { click: _vm.resyncEmailModal },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("settings.accountTab.resyncEmail")
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "btn clickable btn-primary btn-sm email-sync-appointments mr-2",
                            on: {
                              click: function ($event) {
                                return _vm.handleAppointmentClick(email)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("global.words.meeting", 2)) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("email-actions-dropdown", {
                          attrs: {
                            "default-account": email.defaultAccount,
                            "account-id": email.nylasAccountId,
                            "number-of-synced-emails": _vm.isEmailsEmpty,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              !_vm.isEmailsEmpty
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-10 col-12" }, [
                      _c("p", { staticClass: "font-sm moregage-form" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "settings.accountTab.sendAndTrackClientsCommunications"
                              )
                            ) +
                            ":\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-2 col-12 mt-2 d-flex align-items-center justify-content-end",
                      },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.sync-email-terms-modal",
                                modifiers: { "sync-email-terms-modal": true },
                              },
                            ],
                            staticClass: "btn clickable btn-primary btn-sm",
                            on: { click: _vm.connectEmailModal },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("settings.accountTab.connectEmail")
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-10 col-12 mt-4" },
                  [
                    _c("p", { staticClass: "font-sm" }, [
                      _c("span", { staticClass: "bold text-capitalize" }, [
                        _vm._v(
                          _vm._s(_vm.$tc("global.words.note", 1)) +
                            ":\n              "
                        ),
                      ]),
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "settings.accountTab.customEmailSolutionsMessage"
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "font-sm" }, [
                      _c("span", { staticClass: "bold text-capitalize" }, [
                        _vm._v(
                          _vm._s(_vm.$tc("global.words.note", 1)) +
                            ":\n              "
                        ),
                      ]),
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("notification-messages.deleteSyncedEmail")
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i18n", {
                      staticClass: "font-sm mb-0",
                      attrs: {
                        path: "settings.accountTab.googleApiMessage",
                        tag: "p",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "note",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "bold text-capitalize" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$tc("global.words.note", 1)) +
                                      ":\n                "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "policyLink",
                          fn: function () {
                            return [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: "https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "settings.accountTab.googleApiDataPolicy"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c("h6", { staticClass: "grey-text text-darken-3 m-0" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("settings.accountTab.emailSignature")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-lg-10 col-12" },
                [
                  _c("i18n", {
                    staticClass: "font-sm moregage-form",
                    attrs: {
                      path: "settings.accountTab.afterAnyUpdateToTheEmailSignature",
                      tag: "p",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "save",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v(
                                _vm._s(_vm.$t("global.actions.saveChanges"))
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("email-editor", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editEmail,
                        expression: "editEmail",
                      },
                    ],
                    ref: "emailEditor",
                    attrs: {
                      "email-signature": _vm.emailSignature,
                      "signature-separator": false,
                    },
                    on: { change: _vm.handleEditorChange },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editEmail,
                          expression: "!editEmail",
                        },
                      ],
                      staticClass: "rich-text-editor--reset",
                      attrs: { id: "email-preview" },
                    },
                    [
                      _vm.emailSignature.length
                        ? _c("iframe", {
                            attrs: {
                              srcdoc: _vm.emailSignature,
                              width: "100%",
                              frameborder: "0",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("i18n", {
                        staticClass: "font-italic small",
                        attrs: {
                          path: "settings.accountTab.toCreateYourEmailSignature",
                          tag: "p",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "action",
                            fn: function () {
                              return [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "settings.accountTab.editSignature"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-2 col-12 mt-2 text-right d-flex align-items-center justify-content-end",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary float-right btn-sm",
                      attrs: { id: "toggle-signature", type: "button" },
                      on: { click: _vm.handleToggleEditEmail },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.editEmailButtonText) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sync-emails-modal", {
        attrs: {
          "synced-emails": _vm.syncedEmails,
          "resync-email": _vm.resyncEmail,
        },
      }),
      _vm._v(" "),
      _c("schedule-modal", {
        attrs: { "should-display": _vm.shouldDisplayScheduler },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "row moregage-form justify-content-center align-items-center",
      },
      [
        _c("div", { staticClass: "col-3 text-center" }, [
          _c("img", {
            attrs: {
              src: require("@Shared/@Assets/icon/connected-email-gmail.svg"),
              alt: "connect-email-gmail",
            },
          }),
          _vm._v(" "),
          _c("h6", { staticClass: "text-gray bold small" }, [_vm._v("Gmail")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 text-center" }, [
          _c("img", {
            attrs: {
              src: require("@Shared/@Assets/icon/connected-email-outlook.svg"),
              alt: "connect-email-outlook",
            },
          }),
          _vm._v(" "),
          _c("h6", { staticClass: "text-gray bold small" }, [
            _vm._v("Outlook"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 text-center" }, [
          _c("img", {
            attrs: {
              src: require("@Shared/@Assets/icon/connected-email-yahoo.svg"),
              alt: "connect-email-yahoo",
            },
          }),
          _vm._v(" "),
          _c("h6", { staticClass: "text-gray bold small" }, [_vm._v("Yahoo")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 text-center" }, [
          _c("img", {
            attrs: {
              src: require("@Shared/@Assets/icon/connected-email-icloud.svg"),
              alt: "connect-email-icloud",
            },
          }),
          _vm._v(" "),
          _c("h6", { staticClass: "text-gray bold small" }, [_vm._v("iCloud")]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }